<template>
  <v-text-field
    v-model="searchQuery"
    label="Search MENDmate"
    outlined
    dense
    clearable
    class="search-bar longer-search-bar"
    append-icon="mdi-magnify"
    @input="updateSearch"
  ></v-text-field>
</template>

<script>
export default {
  name: "SearchBar",
  props: {
    value: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      searchQuery: this.value,
    };
  },
  watch: {
    value(newValue) {
      this.searchQuery = newValue;
    },
  },
  methods: {
    updateSearch() {
      this.$emit("input", this.searchQuery);
    },
  },
};
</script>

<style scoped>
.longer-search-bar {
  max-width: 400px; /* Make the search bar smaller */
  width: 100%;
}
</style>
